import React from "react";
import PortalModal from "../../Portals";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import { ContentLoader } from "./ModalLoader.styled";
import { theme as themeConfig } from "../../themes/themes";
import { useLoadingState } from "../../context/LoadingContext";

export const GlobalLoader = () => {
  const { isLoading, isHomeScreen } = useLoadingState();

  if (!isLoading) return null;

  return (
    <PortalModal>
      <ContentLoader loaderHomeScreen={isHomeScreen}>
        <PointersLine color={themeConfig.neutral.black} />
      </ContentLoader>
    </PortalModal>
  );
};
